/**
 * Role based privilege constants
 * @type {Object}
 */
const Privileges = Object.freeze({
  DASHBOARD: 'dashboard',
  WORKBOARD: 'workboard',
  CALENDAR: 'calendar',
  CUSTOMERS: 'customers',
  CATALOG: 'catalog',
  INVENTORY: 'inventory',
  MARKETING: 'marketing',
  REVIEWS: 'reviews',
  REPORTS: 'reports',
  ADD_BUTTON: 'addButton',
  SETTINGS: 'settings',
  NOTIFICATIONS: 'notifications',
  INTERCOM: 'intercom',
  PROFILE: 'profile',
  COMPANIE: 'companies',
  TEMPLATES: 'templates',
  USERS: 'users',
  CUSTOMER_CENTER: 'customer',
});

/**
 * Privileges to entry route map
 * @type {Object}
 */
const PrivilegesEntryRouteMAP = Object.freeze({
  [Privileges.DASHBOARD]: '/dashboard',
  [Privileges.WORKBOARD]: '/workboard',
  [Privileges.CALENDAR]: '/calendar',
  [Privileges.CUSTOMERS]: '/customers/customers',
  [Privileges.CATALOG]: '/catalog/labor',
  [Privileges.MARKETING]: '/marketing/campaign',
  [Privileges.INVENTORY]: '/inventory/stock',
  [Privileges.REVIEWS]: '/reviews/summary',
  [Privileges.REPORTS]: '/reports/sales',
  [Privileges.ADD_BUTTON]: '/workboard',
  [Privileges.SETTINGS]: '/workboard',
  [Privileges.NOTIFICATIONS]: '/workboard',
  [Privileges.INTERCOM]: '/workboard',
  [Privileges.CUSTOMER_CENTER]: '/customer/customer-center',
});

/**
 * Privilege route to
 * @type {Object}
 */
const PrivilegesRouteIdMap = Object.freeze({
  [Privileges.DASHBOARD]: {
    ROOT: 'main-dashboard',
  },
  [Privileges.WORKBOARD]: {
    ROOT: 'main-workboard',
  },
  [Privileges.CALENDAR]: {
    ROOT: 'main-calendar',
  },
  [Privileges.CUSTOMERS]: {
    ROOT: 'main-customers',
  },
  [Privileges.CATALOG]: {
    ROOT: 'main-catalog',
  },
  [Privileges.MARKETING]: {
    ROOT: 'marketing',
  },
  [Privileges.INVENTORY]: {
    ROOT: 'main-inventory',
  },
  [Privileges.REVIEWS]: {
    ROOT: 'main-reviews',
  },
  [Privileges.REPORTS]: {
    ROOT: 'main-reports',
  },
  [Privileges.SETTINGS]: {
    ROOT: 'main-settings',
  },
  [Privileges.CUSTOMER_CENTER]: {
    ROOT: 'customer-center',
  },
});

export { Privileges, PrivilegesEntryRouteMAP, PrivilegesRouteIdMap };
